export function AuthorizationsRoleScreenMatrix({
  title,
  description,
  roles,
  screens,
  filter,
  onFilterChange,
  onToggle,
  onSetAllScreensForRole,
  testIdPrefix,
}) {
  const q = filter.trim().toLowerCase();
  const visible = q
    ? screens.filter(
        (row) =>
          row.label.toLowerCase().includes(q) ||
          (row.path || '').toLowerCase().includes(q) ||
          row.group.toLowerCase().includes(q),
      )
    : screens;

  return (
    <section
      className="rounded-2xl border border-slate-200/80 bg-white p-4"
      data-testid={`${testIdPrefix}-matrix`}
    >
      <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
      <p className="mt-1 text-xs text-slate-500">{description}</p>
      <input
        className="mt-3 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
        value={filter}
        onChange={(e) => onFilterChange(e.target.value)}
        placeholder="Filter screens…"
        data-testid={`${testIdPrefix}-filter`}
      />
      {roles.length === 0 ? (
        <p className="mt-3 text-xs text-amber-700">Add organisation roles first.</p>
      ) : (
        <div className="mt-3 max-h-[28rem] overflow-auto">
          <table className="min-w-full border-collapse text-left text-xs">
            <thead className="sticky top-0 bg-white">
              <tr className="border-b border-slate-200 text-slate-500">
                <th className="px-2 py-2 font-medium">Role</th>
                <th className="px-2 py-2 font-medium">All visible</th>
                {visible.map((screen) => (
                  <th key={screen.id} className="whitespace-nowrap px-2 py-2 font-medium">
                    {screen.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {roles.map((role) => {
                const allChecked =
                  visible.length > 0 &&
                  visible.every((screen) => screen.allowed_roles.includes(role));
                return (
                  <tr key={role} className="border-b border-slate-100">
                    <td className="px-2 py-2 font-medium text-slate-800">{role}</td>
                    <td className="px-2 py-2">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        onChange={(e) => onSetAllScreensForRole(role, e.target.checked)}
                        aria-label={`Toggle all screens for ${role}`}
                      />
                    </td>
                    {visible.map((screen) => (
                      <td key={`${role}-${screen.id}`} className="px-2 py-2">
                        <input
                          type="checkbox"
                          checked={screen.allowed_roles.includes(role)}
                          onChange={() => onToggle(screen.id, role)}
                          aria-label={`${screen.label} — ${role}`}
                          data-testid={`${testIdPrefix}-${screen.id}-${role}`}
                        />
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
